var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "black"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_735_103517)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.0006 7.28857V13.2761H18.1319C12.3569 13.2761 8.55061 19.1823 9.07561 24.8261C9.20686 25.8761 9.33811 26.4011 9.33811 26.4011L9.60061 27.7136L10.1256 26.0073C11.1756 23.3823 12.7506 20.7573 18.2631 20.8886H18.0006V27.1386L27.1881 17.0823L18.0006 7.28857ZM19.3131 24.1198V19.7073H18.1319C14.1944 19.7073 11.8319 20.3636 9.99436 23.5136C10.6506 19.1823 13.5381 14.5886 18.1319 14.5886H19.3131V10.4386L25.2194 17.2136L19.3131 24.1198Z",
  fill: "black"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_735_103517"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  fill: "white",
  transform: "translate(7.5 7.5)"
})))));
export default SvgIconShare;